export default ({...props}) => {
  const {size} = props.theme
  return `
   .email-textfield{
   .MuiFormLabel-root
    {
     margin-left:${size(2)}px;
    }
  }
  `
}
